import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class SangYongHall extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/HALL_SY/', 'OF_R06_HALL_X.babylon', window.scene, function (newMeshes, particleSystems) {
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes, 200)
      // newMeshes[7].dispose()
      // newMeshes[9].dispose()
    })
  }

  elevator (level) {
    console.log('Moviendo el ascensor al nivel ' + level)
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/SangYongHall.js